import vid from "../../assets/video/pokrovskie-bani-home-scroll.mp4.asset.json";
import { routes } from "../../lib/nav";
import { SITE_URL } from "../../lib/site";
import type { CaseStudy } from "./types";

const dir = "/cases/pokrovskie-bani";

const img = (
  file: string,
  alt: string,
  span: 2 | 3 | 6 = 3,
  width = 1440,
  height = 900,
) => ({
  src: `${dir}/${file}.webp`,
  src900: `${dir}/${file}-900.webp`,
  alt,
  width,
  height,
  wide: span === 6,
  span,
});

const mobile = (file: string, alt: string) => ({
  src: `${dir}/${file}.webp`,
  src900: `${dir}/${file}-900.webp`,
  alt,
  width: 1920,
  height: 1700,
  span: 2 as const,
});

export const pokrovskieBani: CaseStudy = {
  slug: "pokrovskie-bani",
  title: "Pokrovskie Bani & Spa",
  cardTitle: "Комплексное продвижение Pokrovskie Bani & Spa",
  subtitle: "Банный, SPA- и wellness-комплекс",
  industry: { label: "HoReCa и Wellness", slug: "horeca-wellness" },
  eyebrow: "Сайт и продвижение · Wellness",
  h1: "Комплексное продвижение Pokrovskie Bani & Spa",
  lead:
    "Создали сайт банного комплекса, выстроили поисковое продвижение, запустили Яндекс Директ и связали рекламу с Яндекс Картами и бронированием.",
  heroButtons: { site: "Смотреть сайт", discuss: "Обсудить продвижение" },

  seo: {
    primaryKeyword: "продвижение банного комплекса",
    secondaryKeywords: [
      "комплексное продвижение банного комплекса",
      "маркетинг банного комплекса",
      "продвижение SPA-комплекса",
      "разработка сайта для банного комплекса",
      "создание сайта бани",
      "SEO для банного комплекса",
      "Яндекс Директ для бани",
      "продвижение бани в Яндекс Картах",
      "геоперформанс для загородного комплекса",
    ],
    semanticEntities: [
      "банный комплекс",
      "SPA и wellness",
      "сайт с бронированием",
      "локальный поисковый спрос",
      "Яндекс Карты",
      "Яндекс Директ",
      "техническая поддержка сайта",
    ],
    excludedKeywords: [
      "баня на Новой Риге",
      "мужская баня",
      "русская баня",
      "банные процедуры",
      "забронировать баню",
      "SPA на Новой Риге",
    ],
    title: "Продвижение Pokrovskie Bani & Spa — кейс HAY",
    description:
      "Кейс HAY.agency: сайт, SEO, Яндекс Директ, Карты и техническая поддержка банного и SPA-комплекса Pokrovskie Bani.",
    h1: "Комплексное продвижение Pokrovskie Bani & Spa",
    slug: "pokrovskie-bani",
    canonicalUrl: `${SITE_URL}/cases/pokrovskie-bani`,
    ogTitle: "Продвижение Pokrovskie Bani & Spa — кейс HAY",
    ogDescription:
      "Сайт банного и SPA-комплекса, SEO, Яндекс Директ, геоперформанс в Картах и постоянная техническая поддержка.",
    ogImage: `${SITE_URL}${dir}/pokrovskie-bani-og.webp`,
    robotsIndex: true,
    datePublished: "2024-03-01",
    dateModified: "2026-08-29",
  },

  links: {
    relatedService: {
      label: "SEO-продвижение сайтов",
      to: routes.seo,
      note: "Страницы услуг, форматов посещения и локальный спрос",
    },
    relatedIndustry: {
      label: "Геоперформанс и Яндекс Карты",
      to: routes.geo,
      note: "Карточка комплекса, маршруты, звонки и отзывы",
    },
    relatedCases: [
      {
        label: "Сайт-портфолио архитектурного бюро Archidica",
        to: "/cases/archidica",
        note: "Премиальная визуальная подача и структура каталога",
      },
      {
        label: "Комплексное продвижение строительной компании ESG",
        to: "/cases/esg",
        note: "Сайт, SEO и Директ для премиального загородного сегмента",
      },
      {
        label: "Продвижение логистической компании System",
        to: "/cases/system-logistic",
        note: "Сайт, SEO, Директ и постоянная поддержка проекта",
      },
    ],
    relatedArticles: [],
  },

  cta: {
    title: "Нужно продвигать банный, SPA- или загородный комплекс?",
    text:
      "Объединим сайт, SEO, Яндекс Директ и Карты в единую систему привлечения гостей.",
    button: "Обсудить продвижение",
  },

  client: {
    name: "Pokrovskie Bani & Spa",
    url: "https://pokrovskie-bani-men.ru/",
    city: "Новая Рига, Московская область",
    industry: "Банный, SPA- и wellness-комплекс",
  },
  year: "Долгосрочное сотрудничество",
  services: [
    "Аналитика и проектирование",
    "UX/UI-дизайн",
    "Разработка сайта",
    "SEO",
    "Яндекс Директ",
    "Геоперформанс",
    "Техническая поддержка",
  ],
  platform: "Сайт комплекса с бронированием и страницами услуг",
  tags: [
    { label: "Корпоративный сайт", to: routes.corporate },
    { label: "SEO", to: routes.seo },
    { label: "Яндекс Директ", to: routes.context },
    { label: "Геоперформанс", to: routes.geo },
  ],
  facts: [
    { label: "Клиент", value: "Pokrovskie Bani & Spa" },
    { label: "Отрасль", value: "Банный, SPA- и wellness-комплекс" },
    { label: "Тип проекта", value: "Сайт и комплексное продвижение" },
    { label: "География", value: "Новая Рига, Московская область" },
  ],

  results: {
    title: "Что реализовали",
    items: [
      "Сайт банного и SPA-комплекса с бронированием",
      "SEO и Яндекс Директ по коммерческому и локальному спросу",
      "Геоперформанс: карточка комплекса, маршруты и звонки из Карт",
      "Постоянную техническую поддержку и развитие проекта",
    ],
  },

  story: [
    {
      title: "Задача",
      paragraphs: [
        "Гость выбирает банный комплекс эмоционально: сначала оценивает атмосферу, потом — программы, цены и приватные пространства. Значит, сайт должен одновременно показывать интерьеры и вести к бронированию, а реклама — приводить людей, готовых приехать за город.",
        "Мы собрали сайт и каналы привлечения в одну систему: поиск, реклама и Яндекс Карты работают на один сценарий — знакомство с комплексом и бронирование визита.",
      ],
    },
  ],
  features: [],

  design: {
    title: "Премиальность без лишнего декора",
    paragraphs: [
      "Основа визуальной подачи — реальные фотографии парных, моечных, ресторана и VIP-комнат. Тёмные интерьерные кадры задают настроение, а интерфейс остаётся спокойным и читаемым.",
      "Карточки услуг построены по одному принципу: фотография, длительность, короткое описание и цена. Гость сравнивает форматы посещения, не переходя между разрозненными страницами.",
    ],
  },

  identity: {
    fonts: [
      { name: "Гротеск Bold", role: "Заголовки и цены", sample: "Покровское парение" },
      { name: "Гротеск Regular", role: "Текст и описания услуг", sample: "Забронировать посещение" },
    ],
    colors: [
      { hex: "#1A1512", name: "Тёмный интерьерный" },
      { hex: "#9C7A4E", name: "Тёплый акцент" },
      { hex: "#F6F3EC", name: "Светлый фон" },
      { hex: "#3E3428", name: "Текст на светлом" },
    ],
  },

  cover: img(
    "pokrovskie-bani-case-cover",
    "Главная страница сайта банного и SPA-комплекса Pokrovskie Bani & Spa",
    6,
    1920,
    1080,
  ),

  coverVideo: vid.url,
  coverPoster: {
    src: `${dir}/pokrovskie-bani-home-scroll-poster.webp`,
    src900: `${dir}/pokrovskie-bani-home-scroll-poster-900.webp`,
    alt: "Скролл главной страницы сайта банного и SPA-комплекса Pokrovskie Bani & Spa",
    width: 1920,
    height: 1080,
    span: 6,
    wide: true,
  },

  gallery: [
    img(
      "pokrovskie-bani-service-catalog",
      "Каталог банных программ с длительностью, описанием и ценой",
      3,
      1920,
      1246,
    ),
    img(
      "pokrovskie-bani-vip-rooms",
      "Страница VIP-комнат: приватные пространства комплекса",
      3,
      1920,
      1246,
    ),
  ],

  responsive: {
    text: [
      "Большая часть гостей изучает комплекс с телефона: смотрит фотографии, выбирает программу и бронирует визит по дороге или вечером дома.",
      "В мобильной версии карточки процедур, цены и кнопка бронирования доступны с любого экрана, а телефон и маршрут вынесены в постоянную зону доступа.",
    ],
    images: [
      mobile("pokrovskie-bani-mobile-entry-services", "Мобильная главная сайта банного комплекса"),
      mobile("pokrovskie-bani-mobile-procedure-price", "Мобильный каталог банных программ"),
      mobile("pokrovskie-bani-mobile-vip-certificates", "Мобильная карточка процедуры и сертификатов"),
      mobile("pokrovskie-bani-mobile-contacts-booking", "Мобильная форма бронирования посещения"),
    ],
  },

  columnBlocks: [
    {
      id: "site",
      title: "От знакомства с комплексом до бронирования",
      paragraphs: [
        "Для гостя важны атмосфера, перечень процедур, цены, ресторан, приватные пространства и понятный способ забронировать посещение. Сайт объединяет эти сценарии и помогает принять решение до первого визита.",
      ],
      columns: [
        {
          title: "Знакомство",
          items: ["Интерьеры комплекса", "О комплексе и парных", "Ресторан", "VIP-комнаты"],
        },
        {
          title: "Выбор",
          items: ["Программы парения", "Мойка и SPA-уходы", "Цены и длительность", "Сертификаты"],
        },
        {
          title: "Действие",
          items: ["Бронирование посещения", "Звонок и маршрут", "Корпоративные мероприятия"],
        },
      ],
      images: [
        img("pokrovskie-bani-atmosphere", "Блок о комплексе с фотографиями парных и моечных зон", 3, 1920, 1246),
        img("pokrovskie-bani-price-programs", "Страница цен с форматами посещения комплекса", 3, 1920, 1246),
        img("pokrovskie-bani-restaurant", "Страница ресторана комплекса", 3, 1920, 1246),
        img("pokrovskie-bani-procedure-detail", "Карточка банной процедуры с описанием, ценой и действием", 3, 1920, 1246),
      ],
      imageCols: 2,
      caption:
        "Пользователь может изучить комплекс, выбрать формат посещения и перейти к бронированию с любой страницы.",
    },
    {
      id: "growth",
      title: "Привлекаем гостей из поиска, рекламы и Яндекс Карт",
      paragraphs: [
        "Три канала работают на одну цепочку: поиск или реклама → сайт либо карточка в Картах → маршрут, звонок или бронирование → посещение комплекса.",
      ],
      columns: [
        {
          title: "SEO",
          items: [
            "Страницы услуг и форматов посещения",
            "Локальный поисковый спрос",
            "Техническая оптимизация",
          ],
        },
        {
          title: "Яндекс Директ",
          items: [
            "Коммерческие и локальные запросы",
            "Переход на релевантную страницу",
            "Акценты на форматах и сертификатах",
          ],
        },
        {
          title: "Геоперформанс",
          items: [
            "Карточка комплекса в Картах",
            "Маршруты, звонки и отзывы",
            "Реклама для пользователей рядом",
          ],
        },
      ],
      images: [
        img("pokrovskie-bani-certificates", "Страница подарочных сертификатов комплекса", 3, 1920, 1246),
        img("pokrovskie-bani-corporate-events", "Страница корпоративных мероприятий в комплексе", 3, 1920, 1246),
        img("pokrovskie-bani-sale-news", "Раздел акций и специальных предложений комплекса", 3, 1920, 1246),
        img("pokrovskie-bani-service-catalog", "Раздел моечных и SPA-программ комплекса", 3, 1920, 1246),
      ],
      imageCols: 2,
      caption:
        "Схема простая: запрос или объявление → сайт либо карточка в Картах → маршрут, звонок или бронирование.",
    },
    {
      id: "support",
      title: "Развиваем проект после запуска",
      paragraphs: [
        "Обновляем услуги, цены, акции и материалы, добавляем новые сценарии, контролируем формы и готовим сайт к рекламным и сезонным нагрузкам.",
      ],
      columns: [
        { title: "Контент", items: ["Услуги и цены", "Акции и новости", "Фотоматериалы"] },
        { title: "Функциональность", items: ["Новые сценарии", "Развитие бронирования"] },
        { title: "Технический контроль", items: ["Работа форм", "Скорость и стабильность"] },
        { title: "Реклама", items: ["Поддержка посадочных страниц", "Сезонные нагрузки"] },
      ],
      images: [
        img("pokrovskie-bani-offers-news", "Блок акций и новостей комплекса на главной странице", 3, 1920, 1246),
        img("pokrovskie-bani-mobile-procedure-price", "Мобильная страница цен комплекса", 3, 1920, 1700),
      ],
      imageCols: 2,
    },
  ],

  servicesDone: {
    title: "Что сделали в проекте",
    items: [
      {
        label: "Разработка сайта",
        to: routes.corporate,
        note: "Проектирование, дизайн и разработка сайта комплекса с бронированием",
      },
      {
        label: "SEO-продвижение",
        to: routes.seo,
        note: "Страницы услуг, форматов посещения и локальный поисковый спрос",
      },
      {
        label: "Ведение Яндекс Директа",
        to: routes.context,
        note: "Коммерческие и локальные запросы с релевантными посадочными",
      },
      {
        label: "Геоперформанс и Яндекс Карты",
        to: routes.geo,
        note: "Карточка комплекса, маршруты, звонки, отзывы и реклама рядом с локацией",
      },
    ],
  },
};
